var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4298 19.7812V11.2812C20.4298 11.126 20.3937 10.9729 20.3242 10.834C20.2548 10.6952 20.154 10.5744 20.0298 10.4812L13.0298 5.23125C12.8567 5.10143 12.6462 5.03125 12.4298 5.03125C12.2134 5.03125 12.0029 5.10143 11.8298 5.23125L4.82981 10.4812C4.70561 10.5744 4.60481 10.6952 4.53538 10.834C4.46595 10.9729 4.42981 11.126 4.42981 11.2812V19.7812C4.42981 20.0465 4.53517 20.3008 4.7227 20.4884C4.91024 20.6759 5.16459 20.7812 5.42981 20.7812H9.42981C9.69503 20.7812 9.94938 20.6759 10.1369 20.4884C10.3245 20.3008 10.4298 20.0465 10.4298 19.7812V16.7812C10.4298 16.516 10.5352 16.2617 10.7227 16.0741C10.9102 15.8866 11.1646 15.7812 11.4298 15.7812H13.4298C13.695 15.7812 13.9494 15.8866 14.1369 16.0741C14.3245 16.2617 14.4298 16.516 14.4298 16.7812V19.7812C14.4298 20.0465 14.5352 20.3008 14.7227 20.4884C14.9102 20.6759 15.1646 20.7812 15.4298 20.7812H19.4298C19.695 20.7812 19.9494 20.6759 20.1369 20.4884C20.3245 20.3008 20.4298 20.0465 20.4298 19.7812Z",
    stroke: "#CB8B65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.b926324184a996d84298a6ee518f0158.svg";
export { ForwardRef as ReactComponent };